window.showProgressBar = function () {
  if ($(".custom-progress-bar").length > 0) {
    $(".custom-progress-bar").show();
  } else {
    $('<div class="custom-progress-bar"/>').appendTo("body");
  }
};
window.hideProgressBar = function () {
  $(".custom-progress-bar").hide();
};

$(document).on("ajax:beforeSend", window.showProgressBar);
$(document).on("ajax:complete", window.hideProgressBar);
